export default __webpack_public_path__ + "static/media/latest-tech.0fabf3d7.png";